import { authPost } from "../http_client.js";
import type { PlayerDto } from "../dto/player.dto.js";
import type { PrizeShotReward } from "../../prize_shot/prize_shot_rules.js";

/**
 * Prize Shot economy on the server. The round itself is played on the device;
 * the server only moves coins: it charges a continue and grants what the round
 * found, once per `round_id` (the ISO start of the event period). Until the
 * routes exist the server answers 404 and the client settles locally.
 */
export interface PrizeShotEconomyResponse
{
  player: PlayerDto;
}

export function continuePrizeShot( round_id: string, continue_index: number, price: number, shots: number ): Promise<PrizeShotEconomyResponse>
{
  return authPost<PrizeShotEconomyResponse>( "api/player/me/prize-shot/continue", { round_id, continue_index, price, shots } );
}

export function claimPrizeShot( round_id: string, rewards: PrizeShotReward[] ): Promise<PrizeShotEconomyResponse>
{
  return authPost<PrizeShotEconomyResponse>( "api/player/me/prize-shot/claim", { round_id, rewards } );
}
